import React, { useState, useEffect } from 'react'
import PrivateRoute from '../../components/PrivateRoute'
import AdminRoute from '../../components/AdminRoute'
import { useNavigate, useParams } from 'react-router-dom'


import {
  Card,
  CardContent,
  Switch,
  FormControlLabel,
  Typography,
  TextField,
  Button,
  LinearProgress,
  Alert,
  Box
} from '@mui/material'

import { useDispatch, useSelector } from 'react-redux'
import { editPlaylist, getPlaylist } from '../../actions/playlistActions'

const EditPlaylist = () => {
  const [checked, setChecked] = useState(false)
  const [title, setTitle] = useState('')

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { id } = useParams()
  const { loading, error } = useSelector(state => state.playlistState)
  const { playlist } = useSelector(state => state.playlistState)

  console.log(checked)

  useEffect(() => {
    dispatch(getPlaylist(id))
  }, [])

  useEffect(() => {
    if (playlist) {
      setTitle(playlist.title)
      setChecked(playlist.isPublic)
    }
  }, [playlist])

  const submitHandler = e => {
    e.preventDefault()
    dispatch(editPlaylist(id, title, checked, navigate))
  }

  return (
    <PrivateRoute>
      <Card sx={{ maxWidth: 650, mx: 'auto', mt: 5 }}>
        {loading && <LinearProgress />}

        <CardContent sx={{ p: 3 }}>
          <Typography gutterBottom variant='h6'>Edit Playlist</Typography>
          {error && <Alert severity='error'>{error}</Alert>}

          <form onSubmit={submitHandler}>
            <Box sx={{ display: 'flex', alignItems: 'center', my: 2 }}>
              <Typography sx={{ mr: 1.5 }}>Private</Typography>
              <FormControlLabel
                control={<Switch checked={checked} onChange={e => setChecked(e.target.checked)} />}
                label='Public'
              />
            </Box>

            <TextField
              label='Title'
              fullWidth
              sx={{ mb: 2 }}
              name='title'
              value={title}
              onChange={e => setTitle(e.target.value)}
            />
            <Button variant='contained' type='submit' fullWidth sx={{ mt: 1 }}>Submit</Button>
          </form>
        </CardContent>
      </Card>
    </PrivateRoute>
  )
}

export default EditPlaylist